<template>
    <div>
        <v-toolbar flat color="white">
            <v-toolbar-title v-ripple style="cursor: pointer" @click="fetchData(onlyTrashed)">
                <v-tooltip top>
                    <template v-slot:activator="{ on }">
                        <span v-on="on">Funcionários {{onlyTrashed ? ' removidos' : ''}}</span>
                    </template>
                    <span>Clique para actualizar</span>
                </v-tooltip>
            </v-toolbar-title>
            <v-divider
                class="mx-2"
                inset
                vertical
            ></v-divider>
            <v-spacer></v-spacer>
            <v-text-field 
                class="mr-2 mb-2" fill-height
                v-model="search"
                append-icon="search"
                label="procurar funcionários..."
                clearable
                single-line
                hide-details
            ></v-text-field>

            <!--Dialog for add and edit-->
            <v-btn color="primary" v-if="!onlyTrashed && permissionToAdd" icon @click="openModal"><v-icon>add</v-icon></v-btn>

        </v-toolbar>


        <!--Data table-->
        <v-data-table xs12 sm6 md4
            :headers="headers"
            :items="users"
            :loading="loading"
            class="elevation-1"
            :no-data-text="noDataText()"
            :rows-per-page-items="Global.ROWS_PER_PAGE"
            no-results-text="nenhum resultado"
            rows-per-page-text="por página"
            :pagination.sync="pagination"
            hide-actions
            disable-initial-sort
        >
            <v-progress-linear small v-slot:progress color="indigo" indeterminate></v-progress-linear>
            <template slot="items" slot-scope="props" >
                <td class="text-xs-left">{{ props.item.name }}</td>
                <td class="text-xs-left">{{ props.item.group ? props.item.group.name : 'indefinido'}}</td>
                <td class="text-xs-left">
                    <span :style="!props.item.email ? {'color': 'lighten-2'} : {'color': ''}">{{ props.item.email ? props.item.email : '--indefinido--' }}</span>
                </td>
                <td class="text-xs-left"><v-chip small outline :color="props.item.access ? 'green' : 'red'">{{ props.item.access ? 'Sim' : 'Não' }}</v-chip></td>
                <td class="text-xs-right">{{ props.item.created_at | formatDate}}</td>
                <td class="text-xs-right" style="min-width: 140px; padding-right: 10px;">
                    <v-icon v-ripple v-if="!onlyTrashed" small class="mr-2" @click="showItem(props.item)">visibility</v-icon>
                    <v-icon v-ripple v-if="!onlyTrashed && permissionToUpdate" small class="mr-2" @click="editItem(props.item)">edit</v-icon>
                    <v-icon v-ripple v-if="!onlyTrashed && permissionToDelete && canDelete(props.item)" small class="mr-2" @click="deleteItem(props.item)">block</v-icon>
                    <v-icon v-ripple v-if="onlyTrashed" small class="mr-2" @click="restoreTrashedItem(props.item)">replay</v-icon>
                    <!--<v-icon v-ripple v-if="onlyTrashed" small class="mr-2" @click="deleteTrashedItem(props.item)">delete</v-icon>-->

                    <v-menu offset-y left v-if="!onlyTrashed && permissionToChangePass">
                        <template v-slot:activator="{ on }">
                            <v-icon class="mr-2" v-ripple v-on="on">
                                arrow_drop_down
                            </v-icon>
                        </template>
                        <v-list>
                            <v-list-tile @click="openChangePass(props.item)" :disabled="!props.item.access">
                                <v-list-tile-title>Alterar Senha</v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu>

                </td>
            </template>
            <template v-slot:footer>
                <td :colspan="headers.length">
                    <custom-pagination
                        :totalData="totalData"
                        @onPaginationChange="paginationChangeCallBack($event)"
                        :disabled="loading"
                    ></custom-pagination>
                </td>
            </template>
            <template v-if="error_fetching" slot="no-data">
                <v-btn flat color="primary" @click="fetchData(onlyTrashed)"><v-icon>refresh</v-icon></v-btn>
                <span class="text-xs-center">nenhum dado encontrado</span>
            </template>
        </v-data-table>

        <!--Confirmation Dialog-->
        <v-dialog persistent max-width="290" v-model="openConfirmationDialog" @close="openConfirmationDialog = false">
            <v-card>
                <!--<v-card-title class="headline">Use Google's location service?</v-card-title>-->
                <v-card-text class="text-xs-center">
                    <p v-if="confirmationModalOp === 1">Tens a certeza que queres eliminar <br> <b>{{selectedUser.name}}</b>?</p>
                    <p v-if="confirmationModalOp === 2">Tens a certeza que queres <br> <span class="green--text text--darken-2">restaurar</span> <br><b>{{selectedUser.name}}</b>?</p>
                    <p v-if="confirmationModalOp === 3">Tens a certeza que queres <br> <span class="red--text text--darken-2">eliminar permanentemente</span> <br><b>{{selectedUser.name}}</b>?</p>

                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <div v-if="!loading_modal">
                        <v-btn color="red darken-1" flat @click="confirmationDialogYes">Sim</v-btn>
                        <v-btn color="grey darken-1" flat @click="close">Não</v-btn>
                    </div>
                    <v-progress-circular v-else indeterminate color="primary" m-2 ></v-progress-circular>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!--Button Removed users-->
        <v-btn @click="fetchData(!onlyTrashed)" slot="activator" dark small :color="onlyTrashed ? 'red' : 'indigo'">
            {{onlyTrashed ? 'Sair de ' : ''}}Funcionários removidos
        </v-btn>

        <!--<div>-->
        <!--<button @click.prevent="openMyDialog()">my button</button>-->
        <!--</div>-->

        <!--Change Password-->
        <change-password v-if="showChangePasswordModal"></change-password>

    </div>
</template>

<script>
    import Vue from 'vue';
    import {mapGetters} from 'vuex';
    import {eventBus} from "../../main";
    import {Permissions, Global} from "../../config";
    import CustomPagination from '../extra/CustomPagination.vue';

    import ChangePassword from './ChangePassword'

    export default {
        name: 'user',

        created () {
            let vm = this;
            this.onUserAddOrEdited(vm);
            this.onPassChanged(vm);
            this.users = [];
        },
        beforeDestroy(){
            eventBus.$off('onPasswordChanged');
            eventBus.$off('onUserAdded');
            this.close();
        },

        mounted(){
        },

        data(){
            return {
                Global,
                pagination: {},
                totalData: 0,
                Permissions: Permissions,
                loading: false, //loading for list of users in the datatable
                loading_modal: false, //loading for the action buttons in form modal
                error_fetching: false,  //error for fetching list of users in the datatable
                search: '', //search for the datatable
                openConfirmationDialog: false, //loads confirmation modal with yes or no
                headers: [
                    { text: 'Nome', align: 'left', value: 'name' },
                    { text: 'Grupo', align: 'left', value: 'group.name'},
                    { text: 'Email', align: 'left', value: 'email'},
                    { text: 'Acesso', align: 'left', value: 'access' },
                    { text: 'Adicionado em', align: 'right', value: 'created_at' },
                    { text: 'Actions', align: 'right', value: '', sortable: false }
                ],

                users: [],
                accesss: [{id: 0, name: 'inativo'}, {id: 1, name: 'ativo'}],
                selectedIndex: -1, //the index of the selected user, useful for delete, add, update, restore, permanently delete
                onlyTrashed: false, //displays only trashed items or not
                confirmationModalOp: 0, //used for getting the confirmation actions (delete, restore, permanently delete) from confirmation modal

            }
        },

        components: {
            ChangePassword,
            CustomPagination,
            // ConfirmationDialog,
        },

        watch: {
            pagination(){
                this.fetchData();
            },
            search() {
                if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(() => {
                    this.fetchData();
                }, 800);
            },
        },

        computed: {
            ...mapGetters([
                'getNewUser',
                'getNewCompany',
                'getToken',
                'loggedUser'
            ]),

            permissionToAdd(){
                return this.hasPermission(Permissions.USER_ADD);
            },
            permissionToUpdate(){
                return this.hasPermission(Permissions.USER_UPDATE);
            },
            permissionToDelete(){
                return this.hasPermission(Permissions.USER_DELETE);
            },
            permissionToChangePass(){
                return this.hasPermission(Permissions.USER_CHANGE_PASS);
            },
            isFiltering(){
                return this.search != null;
            },
            showUserModal: {
                get(){
                    return this.$store.getters.getShowUserModal;
                },
                set(value){
                    this.$store.dispatch('setShowUserModal', value);
                }
            },
            selectedCompany: {
                get(){
                    return this.$store.getters.getSelectedCompany;
                },
                set(value){
                    this.$store.dispatch('setSelectedCompany', value);
                }
            },
            selectedUser: {
                get(){
                    return this.$store.getters.getSelectedUser;
                },
                set(value){
                    this.$store.dispatch('setSelectedUser', value);
                }
            },
            userShow: {
                get(){
                    return this.$store.getters.getUserShow;
                },
                set(value){
                    this.$store.dispatch('setUserShow', value);
                }
            },
            showChangePasswordModal: {
                get(){
                    return this.$store.getters.getShowChangePasswordModal;
                },
                set(value){
                    this.$store.dispatch('setShowChangePasswordModal', value);
                }
            },
            groups: {
                get(){
                    return this.$store.getters.getGGroups;
                },
                set(value){
                    this.$store.dispatch('setGGroups', value);
                }
            },

        },

        methods: {

            paginationChangeCallBack(payload){
                this.pagination.rowsPerPage = payload.byPage;
                this.pagination.page = payload.currentPage;
                this.fetchData();
            },

            canDelete(item){
                return this.loggedUser.id !== item.id && this.isGroupAdmin();
            },
            noDataText(){
                return this.loading ? 'a carregar funcionários ...' : 
                        this.onlyTrashed ? 'Nenhum funcionário removido.' : 'nenhum funcionário.';
            },

            fetchData(onlyTrashed = false){
                if(this.loading) return;
                try{
                    this.onlyTrashed = onlyTrashed;
                    let url = onlyTrashed ? 'user/trashed' : 'user';

                    this.users = [];
                    this.loading = true;
                    this.error_fetching = false;

                    Vue.axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.getToken;
                    Vue.axios.get(url, {
                        params: {
                            pag_size: this.pagination.rowsPerPage,
                            pag_current: this.pagination.page,
                            sort_field: this.getSortBy(this.pagination),
                            sort_order: this.getSortDes(this.pagination),
                            search: this.search,
                        }
                    })
                    .then(response => {
                        // this.consoleLog(response);
                        this.consoleLog(response);
                        if(!response.data.success){
                            this.loading = false;
                            this.error_fetching = true;
                            this.handleErrorCodeMessage(response.data);
                            return;
                        }
                        if(response.data.response === 'notAuthorized'){
                            this.showSnackBar('Nao tens permissão.', 'info');
                            this.loading = false;
                            this.error_fetching = true;
                            return;
                        }
                        this.users = response.data.response.users;
                        this.groups = response.data.response.groups;

                        this.totalData = response.data.response.total_data;

                        this.loading = false;
                    }).catch(error => {
                        this.consoleLog(error);
                        this.loading = false;
                        this.error_fetching = true;
                        this.showSnackBar('Erro ao carregar lista de utilizadores', 'error');
                    });
                }catch (e) {
                    this.consoleLog(e);
                    this.showSnackBar('Ocorreu um erro ao carregar lista de utilizadores!!', 'error');
                    this.loading_modal = false;
                }
            },

            delete(){
                try{
                    this.loading_modal = true;
                    let name = this.selectedUser.name;
                    Vue.axios.delete('user/'+this.selectedUser.id)
                        .then(response => {
                            this.consoleLog(response);
                            if(!response.data.success){
                                this.showSnackBar('Erro ao remover utilizador', 'error');
                                return;
                            }
                            if(response.data.response === 'notAuthorized'){
                                this.showSnackBar('Não tens permissão.', 'info');
                                return;
                            }
                            this.users.splice(this.selectedIndex, 1);
                            this.showSnackBar(name+' removido com sucesso', 'success');
                        }).catch(error => {
                        this.consoleLog(error);
                        this.showSnackBar('Ocorreu um erro ao remover utilizador', 'error');
                    }).finally( ()=> {
                        this.loading_modal = false;
                        this.openConfirmationDialog = false;
                        this.selectedUser = this.getNewUser;
                    });
                }catch (e) {
                    this.showSnackBar('Ocorreu um erro ao remover utilizador!', 'error');
                    this.loading_modal = false;
                }
            },

            restoreTrashed(){
                try{
                    this.loading_modal = true;
                    let name = this.selectedUser.name;
                    Vue.axios.put('user/trashed/restore/'+this.selectedUser.id)
                        .then(response => {
                            if(!response.data.success){
                                this.$toastr.error('Erro ao remover utilizador', '');
                                this.loading_modal = false;
                                return;
                            }
                            this.users.splice(this.selectedIndex, 1);
                            this.showSnackBar(name+' restaurado com sucesso', 'success');
                        }).catch(error => {
                        // this.consoleLog(error);
                        this.showSnackBar('Erro ao restaurar utilizador', 'error');
                    }).finally( ()=> {
                        this.loading_modal = false;
                        this.openConfirmationDialog = false;
                        this.selectedIndex = -1;
                        this.selectedUser = this.getNewUser;
                    });
                }catch (e) {
                    this.showSnackBar('Ocorreu um erro ao restaurar utilizador!', 'error');
                    this.loading_modal = false;
                }
            },

            deleteTrashed(){
                try{
                    this.loading_modal = true;
                    let name = this.selectedUser.name;
                    Vue.axios.delete('user/trashed/delete/'+this.selectedUser.id)
                        .then(response => {
                            if(!response.data.success){
                                this.$toastr.error('Erro ao remover utilizador', '');
                                this.loading_modal = false;
                                return;
                            }
                            this.users.splice(this.selectedIndex, 1);
                            this.showSnackBar(name+ ' foi eliminado permanentemente com sucesso', 'success');
                        }).catch(error => {
                            this.showSnackBar('Erro ao eliminar permanentemente o utilizador', 'error');
                            // this.consoleLog(error);
                    }).finally( ()=> {
                        this.loading_modal = false;
                        this.openConfirmationDialog = false;
                        this.selectedIndex = -1;
                        this.selectedUser = this.getNewUser;
                    });
                }catch (e) {
                    this.showSnackBar('Ocorreu um erro ao eliminar permanentemente a utilizador!', 'error');
                    this.loading_modal =false;
                    // this.consoleLog(e);
                }
            },

            onUserAddOrEdited(vm){
                eventBus.$on('onFormUserDone', function(){
                    vm.fetchData();
                })
            },

            onPassChanged(vm){
                eventBus.$on('onPasswordChanged', function(response){
                    try{
                        if(!response || !response.data.success){
                            vm.showSnackBar('Erro ao alterar senha..', 'error');
                            return;
                        }
                        if(response.data.response === 'notAuthorized'){
                            vm.showSnackBar('Não tens permissão.', 'info');
                            return;
                        }

                        vm.showSnackBar('Alteração da senha com successo', 'success');
                        vm.close();
                    }catch (e) {
                        vm.showSnackBar('Erro ao alterar senha...', 'error');
                    }
                })
            },

            getContactsJson(item){
                if(!item.contacts_json) return [];
                if(item.contacts_json instanceof Array)
                    return item.contacts_json;
                else
                    return JSON.parse(item.contacts_json);
            },

            openChangePass(item){
                this.selectedUser = item;
                this.showChangePasswordModal = true
            },

            openModal(){
                this.selectedUser = this.getNewUser;
                this.showUserModal = true;
                eventBus.$emit('onUserFormOpened', true, true);
            },

            showItem (item) {
                this.userShow = true;
                this.selectedIndex = this.users.indexOf(item);
                this.selectedUser = item;
                this.selectedUser.contacts_json = this.getContactsJson(item);
                this.consoleLog(JSON.stringify(this.selectedUser));
                this.showUserModal = true;
                eventBus.$emit('onUserFormOpened', true, true);
            },

            editItem (item) {
                this.selectedIndex = this.users.indexOf(item);
                this.selectedUser = item;
                this.selectedUser.contacts_json = this.getContactsJson(item);
                this.showUserModal = true;
                eventBus.$emit('onUserFormOpened', true, true);
            },

            deleteItem (item) {
                this.confirmationModalOp = 1;
                this.selectedIndex = this.users.indexOf(item);
                // this.$store.dispatch('setSelectedUser', item);
                this.selectedUser = item;
                this.openConfirmationDialog = true;
            },

            restoreTrashedItem (item){
                this.confirmationModalOp = 2;
                this.selectedIndex = this.users.indexOf(item);
                this.selectedUser = item;
                this.openConfirmationDialog = true;
            },

            deleteTrashedItem (item){
                this.confirmationModalOp = 3;
                this.selectedIndex = this.users.indexOf(item);
                this.selectedUser = item;
                this.openConfirmationDialog = true;
            },

            close () {
                this.showUserModal = false;
                this.openConfirmationDialog = false;
                this.loading = false;
                this.userShow = false;
                if(this.$v) this.$v.$reset();
                setTimeout(() => {
                    this.selectedUser = null;
                    this.selectedIndex = -1
                }, 300)
            },

            getNewEmptyContact(){
                return { phone: '', mobile_phone: '', email: '', fax: ''}
            },

            confirmationDialogYes(){
                if(this.confirmationModalOp === 1){
                    this.delete();
                }else if(this.confirmationModalOp === 2){
                    this.restoreTrashed();
                }else if(this.confirmationModalOp === 3){
                    this.deleteTrashed();
                }
            },

        },


    }
</script>

<style scoped>
    .mborder {
        border: 1px solid black;
    }
</style>